import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { getAllArticulos } from '../../actions/tipo_articulos_actions';
import { getTipoZonaIva } from '../../actions/tipo_zona_iva_actions';
import { modifyProductoDeZona, addProductoDeZona, removeProductoDeZona } from '../../actions/zona_productos_actions';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';



const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class ZonaProductos extends React.Component {

    componentDidMount() {

        this.props.getAllArticulos();
        this.props.getTipoZonaIva();

    };


    modifyProducto = (producto) => {
        this.props.setSaveState(true);
        this.props.modifyProductoDeZona(producto);
    };

    addProducto = (producto) => {
        this.props.setSaveState(true);
        this.props.addProductoDeZona(producto);
    };

    messageError = (error) => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkProducto = (producto) => {

        if (this.props.zonaProductos.find(p => (p.descr === producto.descr) && (p.id !== producto.id))) {
            this.messageError(`Ya existe un producto ${producto.descr}`);
            return false;
        }
        
        else return true;

    };


    editProduct = (producto) => {

        this.props.openDialog('EditZonaProduct', {
            producto: producto,
            zonaProductos: this.props.zonaProductos,
            allproductos: this.props.allproductos,
            tipoZonaIva: this.props.tipoZonaIva,
            elemNoCajaId: this.props.elemNoCajaId,
            okHandler: this.modifyProducto,
            checkProducto: this.checkProducto
        }, uuidv4());
    };

    newProduct = () => {

        this.props.openDialog('EditZonaProduct', {
            producto: {},
            zonaProductos: this.props.zonaProductos,
            allproductos: this.props.allproductos,
            tipoZonaIva: this.props.tipoZonaIva,
            elemNoCajaId: this.props.elemNoCajaId,
            okHandler: this.addProducto,
            checkProducto: this.checkProducto
        }, uuidv4());

    };

    removeProduct = producto => {
        this.props.setSaveState(true);
        this.props.removeProductoDeZona(producto);
    };


    render() {

        const { classes } = this.props;


        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Productos de Venta</Typography>

                {this.props.zonaProductos && !this.props.isLoading ?
                <NeuriteGrid
                id="z_p"
                    columns={[
                        { key: 'descr', name: 'Tipo Producto', editable: false, dragable: false, width: 140 },
                        { key: 'ctaDebe', name: 'Debe', editable: false, dragable: false, width: 75 },
                        { key: 'ctaHaber', name: 'Haber', editable: false, dragable: false, width: 75 },
                        { key: 'ctaIva', name: 'IVA', editable: false, dragable: false, width: 75 },
                        { key: 'tipoZonaIva', name: 'Tipo Zona IVA', editable: false, dragable: false, width: 100 },
                        { key: 'activo', name: 'Activo', editable: false, dragable: false, type: 'bool', width: 55  },
                    ]}
                    rows={this.props.zonaProductos}
                    buttonEdit={true}
                    buttonDelete={true}
                    buttonNew={true}
                    onNewRowClick={this.newProduct}
                    onEditClick={this.editProduct}
                    onDeleteClick={this.removeProduct}
                    height={200}
                />
                : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}

            </div>
        );

    };

};

ZonaProductos.propTypes = {
    //state
    zonaProductos: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    allproductos: PropTypes.array.isRequired,
    tipoZonaIva: PropTypes.array.isRequired,
    elemNoCajaId: PropTypes.number,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getAllArticulos: PropTypes.func.isRequired,
    modifyProductoDeZona: PropTypes.func.isRequired,
    addProductoDeZona: PropTypes.func.isRequired,
    removeProductoDeZona: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        zonaProductos: state.zonaProductos.zonaProductos,
        isLoading: state.zonaProductos.isLoading,
        allproductos: state.allArticulos,
        tipoZonaIva: state.tipoZonaIva,
        tipoZonaIva: state.tipoZonaIva,
        elemNoCajaId: state.zonaDetalles.zona.elemNoCajaId
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        getAllArticulos,
        getTipoZonaIva,
        modifyProductoDeZona,
        addProductoDeZona,
        removeProductoDeZona,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ZonaProductos));